import { component } from "picoapp";
import $ from "jquery";

export default component((node) => {
  $(node).on("click", (e) => {
    $(e.target).find("input").trigger("click");
  });
});
